import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import DashboardPage from "@/pages/DashboardPage";
import TripsPage from "@/pages/TripsPage";
import TripDetailPage from "@/pages/TripDetailPage";
import ProvidersPage from "@/pages/ProvidersPage";
import TemplatesPage from "@/pages/TemplatesPage";
import UsersPage from "@/pages/UsersPage";
import EmailsPage from "@/pages/EmailsPage";
import ReconfirmationsPage from "@/pages/ReconfirmationsPage";
import LearningPage from "@/pages/LearningPage";
import RepliesPage from "@/pages/RepliesPage";
import ReportsPage from "@/pages/ReportsPage";
import "@/App.css";

function PrivateRoute({ children, adminOnly = false, allowedRoles = null, feature = null }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-sm text-gray-500">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />;
  if (feature && !user.features?.[feature]) return <Navigate to="/" replace />;
  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user?.role === "reconfirmador") return <Navigate to="/reconfirmaciones" replace />;
  return <DashboardPage />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<HomeRedirect />} />
            <Route
              path="itinerarios"
              element={
                <PrivateRoute allowedRoles={["admin", "agent"]}>
                  <TripsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="itinerarios/:id"
              element={
                <PrivateRoute allowedRoles={["admin", "agent"]}>
                  <TripDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="proveedores"
              element={
                <PrivateRoute allowedRoles={["admin", "agent"]}>
                  <ProvidersPage />
                </PrivateRoute>
              }
            />
            <Route
              path="plantillas"
              element={
                <PrivateRoute allowedRoles={["admin", "agent"]}>
                  <TemplatesPage />
                </PrivateRoute>
              }
            />
            <Route
              path="correos"
              element={
                <PrivateRoute allowedRoles={["admin", "agent"]}>
                  <EmailsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="respuestas"
              element={
                <PrivateRoute allowedRoles={["admin", "agent"]} feature="etapa2">
                  <RepliesPage />
                </PrivateRoute>
              }
            />
            <Route
              path="reconfirmaciones"
              element={
                <PrivateRoute allowedRoles={["admin", "reconfirmador"]}>
                  <ReconfirmationsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="aprendizaje"
              element={
                <PrivateRoute adminOnly feature="etapa2">
                  <LearningPage />
                </PrivateRoute>
              }
            />
            <Route
              path="reportes"
              element={
                <PrivateRoute adminOnly>
                  <ReportsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="usuarios"
              element={
                <PrivateRoute adminOnly>
                  <UsersPage />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
